import { createIcon } from '@chakra-ui/icons';

export const Plus = createIcon({
  displayName: 'Plus',
  viewBox: '0 0 24 24',
  d: 'M24 10.6047V13.3953H13.3953V24H10.6047V13.3953H0V10.6047H10.6047V0H13.3953V10.6047H24Z',
});
